import { useState, useEffect } from 'react';
import { IconButton } from '@upmc/ims.component-library';
import Icon from '../MDC/Icon/Icon';
import { Headline6 } from '../MDC/Typography/Typography';
import StyleAuxiliary from '../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';

import { CSS_CLASSES } from './_constants';
import classes from './Accordion.module.scss';

const Accordion = props => {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (props.expanded) {
			setOpen(true);
		}
	}, [props.expanded]);

	const onClickHandler = () => {
		setOpen(!open);
		if (props.onClick) {
			props.onClick();
		}
	};

	return (
		<StyleAuxiliary classes={classes[CSS_CLASSES.CONTAINER]}>
			<IconButton
				className={classes[CSS_CLASSES.BUTTON]}
				onClick={() => onClickHandler()}
			>
				<Icon icon={open ? 'unfold_less' : 'unfold_more'} />
			</IconButton>
			<Headline6>{props.label}</Headline6>
			{open ? props.children : null}
		</StyleAuxiliary>
	);
};

export default Accordion;
